import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './lancamentoViagemItemForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { 
	iniciar, fechar, getLista,
	initFormItem, getListaItem, salvarItem, excluirItem
 } from './lancamentoViagemActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LancamentoViagemItem from './lancamentoViagemItem';

class LancamentoViagem extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();

		let idInterval = setInterval(() => {
			this.props.getLista();
		}, 30000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvarItem} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluirItem} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		if (this.props.aguardando && !this.props.lista.length) {
			return <div />;
		};

		let lancamentoViagem = this.props.lista[0];

		if (!lancamentoViagem) {
			return (
				<ContentCard>
					<ContentCardBody>
						<Row alignCenter style={{ marginTop: 24 }}>
							<Grid cols='12 12 12 12'>
								<h5 style={{ textAlign: 'center' }}>Você não tem nenhuma folha aberta!</h5>
							</Grid>
						</Row>
						<Row alignCenter style={{ paddingRight: 20, marginTop: 24, marginBottom: 24 }}>
							<Grid cols='7 7 6 4'>
								<Button
									text='Iniciar nova Folha'
									type={'success'}
									icon={'fa fa-plus'}
									event={() => {
										this.props.iniciar();
									}} />
							</Grid>
							<Grid cols='2 2 2 2'>
								<button 
									type='button'
									class='btn btn-success btn-block'
									style={{ width: 39, height: 39 }}
									onClick={() => {
										this.props.getLista();
										this.props.getListaItem();
									}}><i class='fa fa-sync-alt'></i>
								</button>
							</Grid>
						</Row>
					</ContentCardBody>
				</ContentCard>
			);
		}

		return (
			<>
				<ContentCard style={{ backgroundColor: '#007788', color: '#ffffff' }}>
					<ContentCardBody>
						<Row>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, fontWeight: 'bold' }}>Abertura:</p>
							</Grid>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, fontWeight: 'bold', textAlign: 'right' }}>Previsão Acerto:</p>
							</Grid>
						</Row>
						<Row>
							<Grid cols='6 6 6 6'>
							<p style={{ padding: 0, margin: 0 }}>{DateFormat.formatarDataHoraSqlParaTela(lancamentoViagem.datahora_abertura)}</p>
							</Grid>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, textAlign: 'right' }}>{DateFormat.formatarDataHoraSqlParaTela(lancamentoViagem.datahora_previsao_acerto) || 'Não Informada'}</p>
							</Grid>
						</Row>

						<Row>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, fontWeight: 'bold' }}>Despesas:</p>
							</Grid>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, fontWeight: 'bold', textAlign: 'right' }}>Saldo:</p>
							</Grid>
						</Row>
						<Row>
							<Grid cols='6 6 6 6'>
							<p style={{ padding: 0, margin: 0 }}>{FormatUtils.formatarValorTela(lancamentoViagem.valor_despesa, 2)}</p>
							</Grid>
							<Grid cols='6 6 6 6'>
								<p style={{ padding: 0, margin: 0, textAlign: 'right' }}>{FormatUtils.formatarValorTela(lancamentoViagem.valor_saldo, 2)}</p>
							</Grid>
						</Row>

						<Row alignCenter style={{ paddingRight: 20, marginTop: 8, marginBottom: 4 }}>
							<Grid cols='7 7 6 4'>
								<Button
									text='Fechar Folha Atual'
									type={'dark'}
									icon={'fa fa-plus'}
									event={() => {
										if (window.confirm('Deseja realmente fechar a folha atual?')) {
											this.props.fechar(lancamentoViagem);
										}
									}} />
							</Grid>
							<Grid cols='2 2 2 2'>
								<button 
									type='button'
									class='btn btn-success btn-block'
									style={{ width: 39, height: 39 }}
									onClick={() => {
										this.props.getLista();
										this.props.getListaItem();
									}}><i class='fa fa-sync-alt'></i>
								</button>
							</Grid>
						</Row>
					</ContentCardBody>
				</ContentCard>

				<LancamentoViagemItem />
			</>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.lancamentoViagem.modoTela,
	aguardando: state.lancamentoViagem.aguardando,
	lista: state.lancamentoViagem.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	iniciar, fechar, getLista,
	initFormItem, getListaItem, salvarItem, excluirItem
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LancamentoViagem);